import { COPILOT_CHAT_QUERY_PARAM } from 'constants/copilot';

import env from 'helpers/env';

const MEETING_ASK_AVOMA_PATH_RE = /^\/meetings\/([^/]+)\/ask-avoma\/?$/;

/**
 * Returns the meeting uuid if `pathname` is `/meetings/:uuid/ask-avoma`, else null.
 */
export function parseMeetingUuidFromAskAvomaPath(pathname: string): string | null {
  const m = pathname.match(MEETING_ASK_AVOMA_PATH_RE);
  return m ? m[1] : null;
}

/**
 * Path (pathname + optional query) for the meeting Ask Avoma tab.
 */
export function buildMeetingAskAvomaPath(
  meetingUuid: string,
  copilotSessionUuid?: string | null
): string {
  const path = `/meetings/${meetingUuid}/ask-avoma`;
  if (!copilotSessionUuid) {
    return path;
  }
  const qs = new URLSearchParams();
  qs.set(COPILOT_CHAT_QUERY_PARAM, copilotSessionUuid);
  return `${path}?${qs.toString()}`;
}

export function buildMeetingAskAvomaAbsoluteUrl(
  meetingUuid: string,
  copilotSessionUuid?: string | null
): string {
  return `${env.avomaFrontendUrl}${buildMeetingAskAvomaPath(
    meetingUuid,
    copilotSessionUuid
  )}`;
}
